import React from 'react';

const ShopContext = React.createContext(null);
export const ShopProvider = ShopContext.Provider;
export default ShopContext;